"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
const react_1 = __importStar(require("react"));
const __1 = require("../../..");
const Switch_styles_1 = require("./Switch.styles");
/**
 * @deprecated please use <Ds.Switch> instead
 */
const Switch = (_a) => {
    var { colour = "green", size = "small", labelText = undefined, labelVariant = "body", whenOnText = undefined, switchPosition = "left", disabled = false, id = "", testId = "", defaultChecked = false, ariaLabelledby = "" } = _a, props = __rest(_a, ["colour", "size", "labelText", "labelVariant", "whenOnText", "switchPosition", "disabled", "id", "testId", "defaultChecked", "ariaLabelledby"]);
    const [uncontrolledChecked, setUncontrolledChecked] = (0, react_1.useState)(defaultChecked);
    const handleOnChange = (e) => {
        // We only want to change the state if the switch is uncontrolled
        props.controlled !== true &&
            setUncontrolledChecked((prevState) => !prevState);
        props.onChange && props.onChange(e);
    };
    const isChecked = props.controlled ? props.checked : uncontrolledChecked;
    return (react_1.default.createElement(Switch_styles_1.StyledSwitch, { switchPosition: switchPosition },
        props.controlled ? (react_1.default.createElement(ControlledCheckboxInput, { checked: props.checked, disabled: disabled, testId: testId, onChange: handleOnChange, ariaLabelledby: ariaLabelledby })) : (react_1.default.createElement(UncontrolledCheckboxInput, { defaultChecked: defaultChecked, disabled: disabled, testId: testId, onChange: handleOnChange, ariaLabelledby: ariaLabelledby })),
        react_1.default.createElement(Switch_styles_1.StyledChip, { id: id, colour: colour, size: size, active: isChecked },
            react_1.default.createElement(Switch_styles_1.StyledCircle, { size: size, active: isChecked }),
            react_1.default.createElement(__1.Icon, { size: 2, name: isChecked ? "On" : "Off", colour: "white" })),
        react_1.default.createElement(Switch_styles_1.StyledLabel, { switchPosition: switchPosition },
            labelText && (react_1.default.createElement(__1.Text, { variant: labelVariant, skinny: true }, labelText)),
            whenOnText && isChecked && (react_1.default.createElement(__1.Text, { variant: labelVariant, props: { className: "switch_WhenOnText" }, skinny: true }, whenOnText)))));
};
exports.Switch = Switch;
const ControlledCheckboxInput = ({ checked, onChange, disabled = false, testId, ariaLabelledby, }) => {
    return (react_1.default.createElement(Switch_styles_1.StyledHiddenCheckboxInput, { type: "checkbox", checked: checked, onChange: onChange, disabled: disabled, "data-testid": testId, role: "switch", "aria-labelledby": ariaLabelledby }));
};
const UncontrolledCheckboxInput = ({ defaultChecked = false, onChange, disabled, testId, ariaLabelledby, }) => {
    return (react_1.default.createElement(Switch_styles_1.StyledHiddenCheckboxInput, { type: "checkbox", defaultChecked: defaultChecked, onChange: onChange, disabled: disabled, "data-testid": testId, role: "switch", "aria-labelledby": ariaLabelledby }));
};
//# sourceMappingURL=Switch.js.map